// The single source of truth for Costco Shop Card values. The calculator on
// /costco and the tables on /costco-terms both read from here, so they cannot
// disagree. The figures are the agreed Shop Card table; change them only on
// the written word of Manage Your Loans, and update test/shopCardScale.test.js.
//
// Each scale lists the lower bound of every band and its value. A band runs up
// to the next band's lower bound; the last band is open-ended and is the
// maximum. An amount below the first band earns no Shop Card.

const step = (start, size, firstValue, valueStep, count) =>
  Array.from({ length: count }, (_, i) => ({
    from: start + i * size,
    value: firstValue + i * valueStep,
  }));

export const SHOP_CARD_SCALES = {
  home: step(100000, 100000, 200, 200, 20), // $100,000 = $200 ... $2,000,000+ = $4,000
  car: step(10000, 10000, 50, 50, 10), // $10,000 = $50 ... $100,000+ = $500 (the contract cap)
  personal: step(1000, 0, 50, 0, 1).concat(step(10000, 10000, 100, 50, 6)), // $1,000 = $50, $10,000 = $100 ... $60,000+ = $350
};

export const shopCardValue = (type, amount) => {
  const scale = SHOP_CARD_SCALES[type];
  if (!scale || !Number.isFinite(amount)) return 0;
  let value = 0;
  for (const band of scale) if (amount >= band.from) value = band.value;
  return value;
};

const money = (n) => `$${n.toLocaleString('en-AU')}`;

// Rows for the /costco-terms tables: [range label, value label].
export const shopCardRows = (type) => {
  const scale = SHOP_CARD_SCALES[type];
  return scale.map((band, i) => {
    const next = scale[i + 1];
    const last = i === scale.length - 1;
    return [
      last ? `${money(band.from)}+` : `${money(band.from)} to ${money(next.from - 1)}`,
      last ? `${money(band.value)} (maximum)` : money(band.value),
    ];
  });
};
